
import Bignumber from './BignumberMonitorTeares'

export default function BignumbersLoomsFailures({
  label,
  value,
  icon,
  bgColorIcon,
}) {
  return (
    <Bignumber
      label={label}
      value={value}
      icon={icon}
      bgColorIcon={bgColorIcon}
    />
  )
}
